import { t } from "i18next";

import { ESteps } from "types/enums";
import countries from "./countries";

// export const base_url = `https://stud-api.sabir.pro`;
export const base_url = `https://studtur.rudn.ru/api`;

export const files_base_url = `https://studtur.rudn.ru/files`;

export const resolveFileUrl = (src: string): string =>
    src?.replace("https://stud-files.sabir.pro/files", files_base_url) ?? src;

export const isLocalHost = window.location.hostname === "localhost";

export enum TABLES {}

export enum SORT_ORDERS {
    ASC = "ASC",
    DESC = "DESC",
}

export const ROOM_TYPES = [
    `1-но местный номер`,
    `2-х местный номер`,
    `2-х местная квартира`,
    `3-х местный номер`,
    `3-х местная квартира`,
    `4-х местный номер`,
    `4-х местная квартира`,
    `5-ти местный номер`,
    `5-ти местная квартира`,
    `6-ти местный номер`,
    `6-ти местная квартира`,
    `7-ми местный номер`,
    `7-ми местная квартира`,
    `Не типовое размещение`,
];

// export const CURRENCIES = [
//     `руб`,
//     `сом`,
//     `драм`,
//     `тенге`,
//     `сум`,
//     `манат`,
// ];

export const CURRENCIES = countries.map((country) => country.currency);


export const MEAL_PLAN_OPTIONS = [
    { value: `nothing`, label: `Без питания` },
    { value: `breakfastAndDinner`, label: `Завтрак и ужин` },
    { value: `breakfastOnly`, label: `Только завтрак` },
    { value: `full`, label: `Полный пансион` },
];

export const EVENT_TYPES_OPTIONS = [
    { value: `cultural`, label: `Культурно-познавательные`, trackLabel: t("36s8vda98zh") },
    { value: `scientific`, label: `Научно-популярные`, trackLabel: t("9j4vxy32ktr") },
    { value: `proforientation`, label: `Профориентационные`, trackLabel: t("izpi5rxighs") },
    { value: `active_tourism`, label: `Активный туризм`, trackLabel: 'Активный туризм' }
];

/*
Пешеходный туризм
Горный туризм
Водный туризм
Спелеотуризм
Автотуризм
Велосипедный туризм
Конный туризм
Спортивные соревнования по туризму
Альпинизм
Зимний (лыжи, сноуборд)
Комбинированный поход
 */
export const CLUBS_TOURISM_OPTIONS = [
    { value: `Пешеходный туризм`, label: `Пешеходный туризм` },
    { value: `Горный туризм`, label: `Горный туризм` },
    { value: `Водный туризм`, label: `Водный туризм` },
    { value: `Спелеотуризм`, label: `Спелеотуризм` },
    { value: `Автотуризм`, label: `Автотуризм` },
    { value: `Велосипедный туризм`, label: `Велосипедный туризм` },
    { value: `Конный туризм`, label: `Конный туризм` },
    { value: `Спортивные соревнования по туризму`, label: `Спортивные соревнования по туризму` },
    { value: `Альпинизм`, label: `Альпинизм` },
    { value: `Зимний (лыжи, сноуборд)`, label: `Зимний (лыжи, сноуборд)` },
    { value: `Комбинированный поход`, label: `Комбинированный поход` }
];

export const dormitoryQuestionnaireSteps = [
    { name: ESteps.MainInfo, title: `Основная информация` },
    { name: ESteps.Rooms, title: `Комнаты` },
    { name: ESteps.Services, title: `Услуги` },
    { name: ESteps.Rules, title: `Условия заселения` },
    { name: ESteps.Documents, title: `Документы` },
];
